declare interface Array<T> {
  findSafe(predicate: (value: T, index: number, obj: T[]) => boolean): T;
}

Array.prototype.findSafe = function (
  predicate: (value: any, index: number, obj: any[]) => boolean,
) {
  const val = this.find(predicate);
  if (val === undefined) {
    throw new Error(`Cannot find element with predicate: ${predicate}`);
  }
  return val;
};
